// src/components/ConfirmCommand.js
import React, { useEffect, useRef, useState } from "react";
import "./NoLogin.css";


export default function NoLogin({ isOpen, onClose, onConfirm }) {
  const dialogRef = useRef(null);
  const [loading, setLoading] = useState(false);

  

  useEffect(() => {
    if (isOpen) {
      setLoading(false); // reset quand on ouvre
      const btn = dialogRef.current?.querySelector("button");
      btn?.focus();
      const onKey = (e) => e.key === "Escape" && !loading && onClose?.();
      document.addEventListener("keydown", onKey);
      return () => document.removeEventListener("keydown", onKey);
    }
  }, [isOpen, onClose, loading]);

  if (!isOpen) return null;

 const handleConfirm = async () => {
  setLoading(true);

  try {
    await onConfirm?.();        // payer()
    onClose?.();                // ✅ ferme seulement si OK
  } catch (e) {
    console.error("Confirm error:", e);
    // ✅ laisse le modal ouvert pour voir l'erreur
    onClose?.();
  } finally {
    setLoading(false);
    onClose?.();
  }
};

  return (
    <>
     <div className="modal-overlay-confirm" onClick={() => !loading && onClose?.()} aria-modal="true" role="dialog">
      <div
        className="modal-confirm"
        onClick={(e) => e.stopPropagation()}
        ref={dialogRef}
      >
        <h2 className="modal-title-confirm">Confirmation</h2>
        <p className="modal-message-confirm">
          Voulez-vous vraiment valider cette commande ? Vous serez rediriger vers la page de paiement pour payer et finaliser votre achat...
        </p>
        <div className="modal-actions-confirm">
          <button
            className="btn-confirm"
            onClick={handleConfirm}
            disabled={loading}
          >
            Oui
          </button>
          <button
            className="btn-cancel-confirm"
            onClick={onClose}
            disabled={loading}
          >
            Non
          </button>
        </div>
      </div>
    </div>
    </>
  );
}
